import Alpine from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

// import styles bundle
import 'swiper/css';
import 'swiper/css/pagination';
import { AlpineComponentTryba } from '../../../scripts/alpine/include/global';

interface ProductPOIAlpine extends AlpineComponentTryba {
    swiper: Swiper | null;
    open: boolean;
    isZoomed: boolean;
    activeIndex: number;
}

document.addEventListener('alpine:init', () => {
    Alpine.data('initProductPOI', (): ProductPOIAlpine => {
        return {
            swiper: null,
            open: false,
            isZoomed: false,
            poiInViewport: false,
            activeIndex: 0,
            init() {
                if (this.$store.global.isMobile == true) {
                    const swiperParams: SwiperOptions = {
                        modules: [Navigation, Keyboard, Pagination],
                        loop: true,
                        slidesPerView: 1,
                        allowTouchMove: false,
                        keyboard: {
                            enabled: true,
                        },
                        navigation: {
                            prevEl: this.$refs.buttonPrev,
                            nextEl: this.$refs.buttonNext,
                        },
                        pagination: {
                            clickable: true,
                            el: this.$refs.pagination,
                            type: 'fraction',
                        },
                         on: {
                            slideChange: (swiper) => {
                                this.activeIndex = swiper.realIndex;
                            }
                        }
                    };
                    setTimeout(() => {
                        this.swiper = new Swiper(this.$refs.swiperContainer, swiperParams);
                        this.$nextTick(() => {
                            (this.swiper as Swiper).init();
                        });
                    }, 1000);
                }
                (this.$refs.frame.querySelectorAll('.pin') as NodeListOf<HTMLDivElement>).forEach((position: HTMLDivElement) => {
                    position.style.top = `calc(${position.dataset.top}% - 16px)`;
                    position.style.left = `calc(${position.dataset.left}% - 16px)`;
                });
            },
            // Passer l'index de la slide active a activeIndex
            // sliderActive() {
                // if (this.$store.global.isMobile == true) {
                //     setTimeout(() => {
                //         this.activeIndex = (this.swiper as Swiper).realIndex;
                //     }, 200);
                // }
            // },
            // Dézoom + réafficher les autres pins + MAJ states
            reset() {
                const image = this.$refs.frame.querySelector('[x-ref="image"]');
                this.isZoomed = false;
                if (image) {
                    image.style.transform = '';
                }
                (this.$refs.frame.querySelectorAll('.pin') as NodeListOf<HTMLDivElement>).forEach((pin: HTMLDivElement) => {
                    pin.classList.remove('hidden');
                });

                if (this.$store.global.isMobile == false && this.$refs.line) {
                    this.$refs.line.classList.remove('scale-x-100');
                }
            },
            // Zoom sur le pin au click sur les btn du slider
            zoomSliderNavigation() {
                if (this.$store.global.isMobile == true) {
                    setTimeout(() => {
                        const frame = this.$refs.frame;
                        // const image = this.$refs.image;
                        const image = this.$refs.frame.querySelector('[x-ref="image"]');
                        if (frame) {
                            const currentPoint = frame.querySelector('.poi-' + this.activeIndex) as HTMLDivElement;
                            (frame.querySelectorAll('.pin') as NodeListOf<HTMLDivElement>).forEach((pin: HTMLDivElement) => {
                                pin.classList.add('hidden');
                                currentPoint.classList.remove('hidden');
                            });
                            this.isZoomed = true;
                            this.open = true;
                            if (image) {
                                image.style.transform = 'scale(2)';
                                image.style.transformOrigin = `${currentPoint.dataset.left}% ${currentPoint.dataset.top}%`;
                            }
                        }
                    }, 500);
                }
            },
            // Zoom au click sur le poi
            zoomPoi() {
                const image = this.$refs.frame.querySelector('[x-ref="image"]');
                const poi = this.$refs.poi;
                const pins = this.$refs.frame.querySelectorAll('.pin') as NodeListOf<HTMLDivElement>;

                this.open = !this.open;
                if (this.open == true && this.isZoomed == false) {
                    this.isZoomed = true;
                    pins.forEach((pin: HTMLDivElement) => {
                        pin.classList.add('hidden');
                        setTimeout(() => {
                            if (image) {
                                image.style.transform = 'scale(2)';
                                image.style.transformOrigin = `${poi.dataset.left}% ${poi.dataset.top}%`;
                            }
                        }, 200);
                    });

                    poi.classList.remove('hidden');
                } else {
                    if (image) {
                        image.style.transform = '';
                    }
                    pins.forEach((pin: HTMLDivElement) => {
                        pin.classList.remove('hidden');
                    });
                    this.isZoomed = false;
                    this.open = false;
                }
            },
            desktopPosition() {
                const line = this.$refs.line;
                const poiContent = this.$refs.poiContent;
                const poiWidth = 150;
                const lineSpacer = 100;
                const position = poiContent.dataset.position;

                if (position == 'left' || position == 'up') {
                    poiContent.style.left = -lineSpacer - poiWidth + 'px';
                } else {
                    poiContent.style.right = -lineSpacer - poiWidth + 'px';
                }
                setTimeout(() => {
                    if (this.open == true) {
                        line.classList.add('scale-x-100');
                        line.style.width = lineSpacer + poiWidth + 'px';
                    } else {
                        line.classList.remove('scale-x-100');
                        line.style.width = 0 + 'px';
                    }
                }, 200);
            },
        };
    });
});
